import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Popper from "@material-ui/core/Popper";
import Paper from "@material-ui/core/Paper";
import EventDetailContent from "./EventDetailContent";
import Emitter from "../../../../emitter";
import { statusColor } from "../../../../util";
import { RecurringEvent } from "icons";

const EventItem = ({ classes, event, itemOpened, handelOpened, ...rest }) => {
  const [open, setOpen] = React.useState(false);
  const arrowRef = React.useRef();
  const anchorRef = React.useRef();

  const ToggleEventDetail = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setOpen((prevOpen) => !prevOpen);
    if (!open) {
      Emitter.emit("OPEN_EVENT");
      setTimeout(() => {
        handelOpened(event.id);
      }, 500);
    }
  };

  React.useEffect(() => {
    setOpen(itemOpened);
  }, [itemOpened]);

  return (
    <Box
      key={event.id}
      className={classes.multipleEntriesItemBox}
      style={{ borderLeftColor: statusColor(event.status) }}
      onClick={ToggleEventDetail}
      ref={anchorRef}
    >
      <Popper
        placement="right"
        open={open}
        anchorEl={anchorRef.current}
        disablePortal={false}
        className={classes.popper}
        modifiers={{
          flip: {
            enabled: true,
          },
          arrow: {
            enabled: true,
            element: arrowRef.current,
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: "viewport",
          },
        }}
      >
        <span className={classes.arrow} ref={arrowRef} />
        <Paper className={classes.paper}>
          <EventDetailContent classes={classes} event={event} {...rest} />
        </Paper>
      </Popper>
      <Typography
        className={classes.buttonText}
        noWrap
        style={open ? { fontWeight: 600 } : null}
      >
        {event.title}
        {event.recurringEventType == "recurring" ? <RecurringEvent /> : null}
      </Typography>
    </Box>
  );
};

export default EventItem;
